function round(value: number, decimals: number) {
  return Number(`${Math.round(Number(`${value}e${decimals}`))}e-${decimals}`);
}

type MediaFileMeta = {
  duration?: number;
  format?: {
    duration?: number;
  };
  width?: number;
  height?: number;
};

type MediaFileShape = {
  meta?: MediaFileMeta;
  size?: {
    width?: number;
    height?: number;
  };
};

export function getMediaFileDuration(mediaFile: MediaFileShape) {
  // files selected from library don't have duration filed in root of meta object
  const meta = mediaFile.meta;
  return meta?.duration || round(meta?.format?.duration || 0, 1);
}

export function getRatio(mediaFile: MediaFileShape) {
  if (mediaFile.size && mediaFile.size.width && mediaFile.size.height) {
    return round(mediaFile.size.width / mediaFile.size.height, 2);
  } else if (mediaFile.meta && mediaFile.meta.width && mediaFile.meta.height) {
    return round(mediaFile.meta.width / mediaFile.meta.height, 2);
  } else {
    return 0.0;
  }
}
